import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';

import EmbeddedIFrame from 'views/Frames/EmbeddedIFrame';
import { ClmPortalIncomingPostMessageTypes } from 'utils/postMessageUtil';
import { useRuntimeConfig } from 'config/useRuntimeConfig';
import { requestHostNavigation } from 'utils/browserUtil';
import { useHost } from 'contexts/Host';
import { TOPBAR_HEIGHT } from 'services/constants';

interface PartnerFrontendIframeProps {
  path: string;
  heightOffset?: string;
  loading?: boolean;
}

const PartnerFrontendIFrame = ({
  path,
  heightOffset = `${TOPBAR_HEIGHT}px`,
  loading = false,
}: PartnerFrontendIframeProps) => {
  const { isWena } = useHost();
  const navigate = useNavigate();
  const runtimeConfig = useRuntimeConfig();

  // Feature flag: when partnersNew is enabled, use /partners-new in pcm-partner-data iframe instead of /partners
  const queryIndex = path.indexOf('?');
  const pathname = queryIndex === -1 ? path : path.slice(0, queryIndex);
  const search = queryIndex === -1 ? '' : path.slice(queryIndex);
  const partnerIframePath =
    runtimeConfig.configData.featureFlags?.partnersNew?.enabled && pathname === '/partners'
      ? `/partners-new${search}`
      : path;

  useEffect(() => {
    //Follow partner frontend URL changes. Temporary solution until the tabs are moved to the container app
    window.addEventListener('message', handleMessage);

    function handleMessage(event: any) {
      const message = event.data.message;
      if (message === ClmPortalIncomingPostMessageTypes.CHANGE_URL) {
        // window.history.replaceState(null, "CLM", event.data.value.url)
        navigate(event.data.value.url);
      }
      if (message === ClmPortalIncomingPostMessageTypes.OPEN_IN_NEW_TAB) {
        if (isWena) {
          requestHostNavigation(event.data.value.routePath);
          return;
        }
        window.open(event.data.value.routePath);
      }
    }

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <>
      <EmbeddedIFrame
        url={`${runtimeConfig.configData.iframeUrls.partnerCoreIframe}${partnerIframePath}`}
        title="Partners"
        id="partner-iframe"
        height={`calc(100% - ${heightOffset})`}
        loading={loading}
      />
    </>
  );
};

export default PartnerFrontendIFrame;
